function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "snow-flake--winter-freeze-snow-freezing-ice-cold-weather-snowflake"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union",
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.085 0.361a1.232 1.232 0 1 0 -1.741 1.741l2.924 2.924v5.241H5.027L2.103 7.344A1.232 1.232 0 0 0 0.361 9.085L2.776 11.5 0.361 13.915a1.232 1.232 0 1 0 1.741 1.741l2.924 -2.924h5.241v5.241l-2.924 2.924a1.232 1.232 0 1 0 1.741 1.741L11.5 20.224l2.415 2.415a1.232 1.232 0 0 0 1.741 -1.741l-2.924 -2.924V12.732h5.241l2.924 2.924a1.232 1.232 0 1 0 1.741 -1.741L20.224 11.5l2.415 -2.415a1.232 1.232 0 0 0 -1.741 -1.741l-2.924 2.924H12.732V5.027l2.924 -2.924A1.232 1.232 0 0 0 13.915 0.361L11.5 2.776 9.085 0.361ZM4.879 4.879a1.232 1.232 0 0 1 1.741 0l1.643 1.643a1.232 1.232 0 0 1 -1.741 1.741l-1.643 -1.643a1.232 1.232 0 0 1 0 -1.741Zm3.384 11.599a1.232 1.232 0 1 0 -1.741 -1.741l-1.643 1.643a1.232 1.232 0 1 0 1.741 1.741l1.643 -1.643Zm9.857 -11.599a1.232 1.232 0 0 1 0 1.741l-1.643 1.643a1.232 1.232 0 1 1 -1.741 -1.741l1.643 -1.643a1.232 1.232 0 0 1 1.741 0Zm-1.643 9.857a1.232 1.232 0 1 0 -1.741 1.741l1.643 1.643a1.232 1.232 0 1 0 1.741 -1.741l-1.643 -1.643Z",
  clipRule: "evenodd",
  strokeWidth: 1
}));

function SvgSnowFlake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "-0.5 -0.5 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowFlake);
export default __webpack_public_path__ + "static/media/snow-flake.f22f6d36.svg";
export { ForwardRef as ReactComponent };